module.exports = __webpack_public_path__ + "media/images/icons/twotone/up-square-1dfa637011f7990a0bcceab39fb97319.svg";